<template>
  <div>
    <v-card :loading="loading">
      <v-card-text class="px-8 pt-3">
        <div class="d-flex justify-space-between mb-4">
          <v-btn color="primary" @click="$emit('client-modal')" v-if="hasPermission(512)">
            Adicionar Cliente
          </v-btn>

          <v-btn-toggle v-model="filterType" :color="filterType === 'active' ? 'success' : 'error'">
            <v-btn v-for="(type, index) in ['active', 'inactive']" :key="index" :value="type" depressed>
              {{ type === 'active' ? 'Ativos' : 'Inativos' }}
            </v-btn>
          </v-btn-toggle>
        </div>
        <v-data-table
          :headers="headers"
          :items="filteredClients"
          :search="search"
          :header-props="{ sortByText: 'Ordenar por:' }"
          :sort-desc="false"
          sort-by="fullname"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              filled
              filter
              single-line
              hide-details
              clearable
            ></v-text-field>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <v-chip :color="item.type === 'PF' ? 'info' : 'warning'" label small class="font-weight-bold">
              {{ item.type }}
            </v-chip>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <div class="d-flex flex-wrap gap-1">
              <a
                v-for="email in item.email.split(',')"
                :key="email"
                :href="`mailto:${email}`"
                class="text--secondary text-decoration-none"
              >
                {{ email }}
              </a>
            </div>
          </template>
          <template v-slot:[`item.phone`]="{ item }">
            <a
              v-if="item.phone"
              :href="`tel:0${item.phone.replace(/\D/g, '')}`"
              class="text--secondary text-decoration-none"
            >
              {{ item.phone }}
            </a>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <v-chip :color="item.active ? 'success' : 'error'" label small>
              {{ item.active ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <TooltipedBtn title="Editar" @click="editClient(item)" icon v-if="hasPermission(1024)">
              <v-icon>mdi-pencil-outline</v-icon>
            </TooltipedBtn>
            <TooltipedBtn title="Anexos" @click="clientAttachment(item)" icon v-if="hasPermission(1024)">
              <v-icon>mdi-attachment</v-icon>
            </TooltipedBtn>
          </template>
          <template v-slot:no-results>
            <v-btn color="primary" @click="search = ''">Resetar</v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <client-modal @success="getClients" />
    <client-attachment-modal @success="getClients" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CLIENT from '@/services/client'
import ClientModal from '@/components/modals/ClientModal'
import ClientAttachmentModal from '@/components/modals/ClientAttachmentModal'
export default {
  components: { ClientModal, ClientAttachmentModal },
  data: () => ({
    clients: [],
    loading: false,
    search: '',
    filterType: 'active',
    headers: [
      { text: 'Tipo', value: 'type', sortable: true, align: 'start', width: '80' },
      { text: 'Nome', value: 'name', sortable: true },
      // { text: 'E-mail', value: 'email', sortable: false },
      // { text: 'Telefone', value: 'phone', sortable: false },
      { text: 'Status', value: 'active', width: '110', align: 'end' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'end', width: '110' },
    ],
  }),

  methods: {
    clientAttachment(client) {
      this.$emit('client-attachment', client)
    },
    editClient(client) {
      this.$emit('client-modal', client)
    },
    async getClients() {
      try {
        this.loading = true
        const { clients } = await CLIENT.getAll()
        this.clients = clients
        this.loading = false
      } catch (e) {
        console.log(e)
        this.$toast.fire({
          icon: 'error',
          title: e.message || 'Erro ao buscar clientes',
        })
        this.$router.push({ name: 'dashboard' })
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    filteredClients() {
      return this.clients.filter(client => {
        if (this.filterType === 'active') return client.active
        if (this.filterType === 'inactive') return !client.active
        return true
      })
    },
  },

  created() {
    this.getClients()
  },
}
</script>

<style lang="scss" scoped>
.v-card__title {
  text-align: center !important;
  display: inherit;
}
</style>
